import axios from "axios";

const instance = axios.create({
    baseURL: process.env.VUE_APP_ASSESSMENT_API_URL
});
export default {
    install(Vue) {
        const state = Vue.observable({ flags: {} });

        Vue.prototype.$featureFlags = {
            get flags() { return state.flags; },

            async init() {
                try {
                    const { data } = await instance.get('flags', {});
                    state.flags = data.flags;
                } catch (error) {
                    console.error('Failed to load feature flags:', error);
                    state.flags = {};
                }
            },

            isEnabled(flagName) {
                return state.flags[flagName] === true;
            }
        };
    }
};